import { Flex } from "@mantine/core";
import { IconCaretDownFilled } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { Text } from "components";

interface CreditPreparationHeaderProps {
  isExpanded: boolean;
  onToggle: () => void;
}

export const CreditPreparationHeader = ({
  isExpanded,
  onToggle,
}: CreditPreparationHeaderProps) => {
  const { t } = useTranslation();

  return (
    <Flex
      direction="row"
      gap="md"
      mb="md"
      align="center"
      bg="var(--mantine-color-gray-1)"
      w="100%"
      style={{ borderRadius: 20, cursor: "pointer" }}
      onClick={onToggle}
      py="sm"
      px="md"
    >
      <IconCaretDownFilled
        size={20}
        color="black"
        style={{
          transform: isExpanded ? "rotate(0deg)" : "rotate(180deg)",
          transition: "transform 0.3s ease",
        }}
      />
      <Text size="lg" fw={500} c="#8AD572">
        {t("credit.view.tab.preliminaryPreparation")}
      </Text>
    </Flex>
  );
};
